// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingButton_spinner__Z0vK0","lb-spin":"LoadingButton_lb-spin__RJzt7","busy":"LoadingButton_busy__-EVvj"};